import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
/**
 * Page heading shared by the settings tabs: title and optional actions above a
 * hairline rule, with an optional description paragraph below it.
 */
export const SettingsHeader = ({ title, actions, description }) => (_jsxs(Box, { sx: { mb: '1.375rem' }, children: [_jsxs(Box, { sx: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '1rem',
                flexWrap: 'wrap',
                pb: '1rem',
                borderBottom: '1px solid',
                borderColor: 'divider'
            }, children: [_jsx(Typography, { component: 'h1', sx: { fontSize: '1.4375rem', fontWeight: 700, letterSpacing: '-0.02em' }, children: title }), actions ? (_jsx(Box, { sx: { display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }, children: actions })) : null] }), description ? (_jsx(Typography, { sx: { fontSize: '0.875rem', color: 'text.disabled', mt: '1.375rem' }, children: description })) : null] }));
//# sourceMappingURL=settings-header.js.map